import React from 'react'
import BallySportsNBA from 'src/components/page/bally-sports-nba'
import { teamIds } from 'src/constants/personalizationIds'
import { videos } from 'src/constants/videos'

export default (props) => (
  <BallySportsNBA
    location={props.location}
    video={videos.bally_hawks.videoUrl}
    staticAnnotation={videos.bally_hawks.staticAnnotation}
    title="Watch Atlanta basketball live"
    subtitle="Stream the Hawks on FanDuel Sports Network Southeast"
    teamId={teamIds['Atlanta Hawks']}
  />
)
